import ActionTypes from 'app/auth/ActionTypes';
import reducer from 'app/auth/reducer';
import routes from 'app/auth/routes';

export default {
  reducers: {
    auth: reducer,
  },
  actionTypes: ActionTypes,
  routes,
};
